// extracted by mini-css-extract-plugin
export var centerText = "_fa-8";
export var container = "_fa-0";
export var doughnutContainer = "_fa-7";
export var legend = "_fa-a";
export var legendItemColorDisplay = "_fa-b";
export var legendItemLabel = "_fa-d";
export var legendItemValue = "_fa-c";
export var lg = "_fa-5";
export var maxWidth = "_fa-9";
export var md = "_fa-4";
export var responsive = "_fa-6";
export var sm = "_fa-3";
export var xs = "_fa-2";
export var xxs = "_fa-1";